import { Theme } from '@mui/material';

import { DisableTemplatePaddingOn, TRoundedCornersSize, Maybe } from '@shared-components/types';
import { resolveTemplatePadding } from '@utils/resolveTemplatePadding';

const getOrder = (imgDisplaysFirst: boolean) => ({
	'[data-testid="section_content_service_line_hero"]': {
		order: imgDisplaysFirst ? 1 : 0,
	},
	'[data-testid="service_line_hero_video_asset"], [data-testid="service_line_hero_focal_point_image"],[data-testid="service_line_hero_image_asset"], [data-testid="service_line_hero_services"]':
		{
			order: imgDisplaysFirst ? 0 : 1,
		},
});

export const getContainerStyles = (
	theme: Theme,
	disablePaddingOn: DisableTemplatePaddingOn,
	imgDisplaysFirstOnMobile: boolean,
	imgDisplaysFirstOnDesktop: boolean,
	hasWidget?: boolean
) => {
	// Use 'lg' breakpoint (1200px) when a widget is present for more space,
	// otherwise use 'md' breakpoint (900px) for normal behavior
	const breakpoint = hasWidget ? 'lg' : 'md';
	return {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'stretch',
		margin: '0 auto',
		boxSizing: 'border-box',
		position: 'relative',
		...getOrder(imgDisplaysFirstOnDesktop),
		...resolveTemplatePadding(disablePaddingOn, false, '0', '2.625rem'),
		[theme.breakpoints.down(breakpoint)]: {
			flexDirection: 'column',
			alignItems: hasWidget ? 'center' : 'stretch',
			...getOrder(imgDisplaysFirstOnMobile),
			...resolveTemplatePadding(disablePaddingOn, true, '0', '2.625rem'),
		},
	};
};

export const getMediaBorderRadius = (
	mediaWithBorderRadius: Maybe<boolean>,
	imgDisplaysFirstOnDesktop?: Maybe<boolean>,
	mediaRoundedCornerSize?: Maybe<TRoundedCornersSize>
): string => {
	const radiusValues = {
		Small: 1,
		Medium: 2.5,
		Large: 5,
	} as { [key: string]: number };
	const radiusValue = radiusValues[mediaRoundedCornerSize ?? 'Large'];
	const rads = `${radiusValue}rem`;
	const leftRightRadius = imgDisplaysFirstOnDesktop ? `0 ${rads} ${rads} 0` : `${rads} 0 0 ${rads}`;
	return mediaWithBorderRadius === false ? 'none' : leftRightRadius;
};

interface IMediaContainerStyles {
	theme: Theme;
	mediaWithBorderRadius: Maybe<boolean>;
	isVideo?: boolean;
	imgDisplaysFirstOnDesktop?: Maybe<boolean>;
	mediaRoundedCornerSize?: Maybe<TRoundedCornersSize>;
}

export const getMediaContainerStyles = ({
	theme,
	mediaWithBorderRadius = false,
	isVideo = false,
	imgDisplaysFirstOnDesktop = false,
	mediaRoundedCornerSize,
}: IMediaContainerStyles) => {
	return {
		...(isVideo && { position: 'relative', containerType: 'inline-size' }),
		display: 'block',
		flex: '1',
		width: '100%',
		overflow: 'hidden',
		borderRadius: 'none',
		minHeight: 'auto',
		[theme.breakpoints.up('md')]: {
			borderRadius: getMediaBorderRadius(
				mediaWithBorderRadius,
				imgDisplaysFirstOnDesktop,
				mediaRoundedCornerSize
			),
			minHeight: '400px',
		},
	};
};

export const mobileImageStyles = {
	display: 'flex',
	borderRadius: '0',
};
